export default __webpack_public_path__ + "static/media/fondo-marino.b62ed7a0.jpg";